export default "__VITE_ASSET__BFNyNrCb__"